export const RELATED_GUIDES = [
  {
    path: "/ghid-foaie-parcurs-anaf",
    blurb: "cele 4 elemente obligatorii, format acceptat și greșeli frecvente.",
  },
  {
    path: "/deducere-100-combustibil",
    blurb: "condiții pentru TVA și impozit, calcul 50% vs 100% și ce verifică ANAF.",
  },
  {
    path: "/foi-parcurs-pfa",
    blurb: "obligații pentru PFA, deducere și particularități față de firmă.",
  },
  {
    path: "/model-foaie-parcurs",
    blurb: "structură lunară, exemplu completat și diferența față de FAZ.",
  },
  {
    path: "/control-anaf-cheltuieli-autoturism",
    blurb: "dosarul de control: foi, bonuri, facturi, ITP, asigurări, contracte.",
  },
  {
    path: "/automatizare-foi-de-parcurs",
    blurb: "cum reduci timpul fără Excel: rute, validare consum, export pentru contabil.",
  },
  {
    path: "/foi-parcurs-comodat",
    blurb: "mașina pe persoană fizică: comodat, decont de km și foaie de parcurs.",
  },
  {
    path: "/foaie-parcurs-casa-serviciu",
    blurb: "naveta casă–sediu: când e personal, când poate fi de lucru, 50% vs 100%.",
  },
  {
    path: "/norma-de-consum-foaie-parcurs",
    blurb: "cum stabilești norma proprie și cum o leagă ANAF de alimentări și rezervor.",
  },
  {
    path: "/trend-deductibilitate-100-procente",
    blurb: "de ce firmele trec la 100%: costuri, fiscalitate, automatizare și calcule concrete.",
  },
] as const;

export type RelatedGuidePath = (typeof RELATED_GUIDES)[number]["path"];

export function relatedGuidePaths(currentPath: string): string[] {
  return RELATED_GUIDES.filter((guide) => guide.path !== currentPath).map(
    (guide) => guide.path,
  );
}
